













































import Vue from 'vue'
import UiIcon from '../UiIcon'
export default Vue.extend({
  components: {
    UiIcon
  },
  inheritAttrs: false,
  props: {
    value: {
      type: [Object, Array, String, Number, Boolean],
      default: ''
    },
    id: {
      type: String,
      required: true
    },
    label: {
      type: [String, Boolean],
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    trueValue: {
      type: [String, Number, Boolean],
      default: true
    },
    falseValue: {
      type: [String, Number, Boolean],
      default: ''
    }
  },
  data () {
    return {
      isChecked: ''
    }
  },
  watch: {
    value (newVal): void {
      this.isChecked = newVal
    }
  },
  methods: {
    change (): void {
      this.$emit('input', this.isChecked ? this.trueValue : this.falseValue)
    }
  }
})
